/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CampaignMoneyDataSource } from './CampaignMoneyDataSource';
import {
    CampaignMoneyDataSourceFromJSON,
    CampaignMoneyDataSourceFromJSONTyped,
    CampaignMoneyDataSourceToJSON,
    CampaignMoneyDataSourceToJSONTyped,
} from './CampaignMoneyDataSource';

/**
 * 
 * @export
 * @interface CampaignMoneyGraphData
 */
export interface CampaignMoneyGraphData {
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignMoneyGraphData
     */
    labels?: Array<string>;
    /**
     * 
     * @type {Array<CampaignMoneyDataSource>}
     * @memberof CampaignMoneyGraphData
     */
    dataSources?: Array<CampaignMoneyDataSource>;
}

/**
 * Check if a given object implements the CampaignMoneyGraphData interface.
 */
export function instanceOfCampaignMoneyGraphData(value: object): value is CampaignMoneyGraphData {
    return true;
}

export function CampaignMoneyGraphDataFromJSON(json: any): CampaignMoneyGraphData {
    return CampaignMoneyGraphDataFromJSONTyped(json, false);
}

export function CampaignMoneyGraphDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CampaignMoneyGraphData {
    if (json == null) {
        return json;
    }
    return {
        
        'labels': json['labels'] == null ? undefined : json['labels'],
        'dataSources': json['dataSources'] == null ? undefined : ((json['dataSources'] as Array<any>).map(CampaignMoneyDataSourceFromJSON)),
    };
}

export function CampaignMoneyGraphDataToJSON(json: any): CampaignMoneyGraphData {
    return CampaignMoneyGraphDataToJSONTyped(json, false);
}

export function CampaignMoneyGraphDataToJSONTyped(value?: CampaignMoneyGraphData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'labels': value['labels'],
        'dataSources': value['dataSources'] == null ? undefined : ((value['dataSources'] as Array<any>).map(CampaignMoneyDataSourceToJSON)),
    };
}

